export const LOAD_ALL_USERS_IMAGE = "LOAD_ALL_USERS_IMAGE";
export const LOAD_ALL_USERS_IMAGE_SUCCESS = "LOAD_ALL_USERS_IMAGE_SUCCESS";
export const LOAD_ALL_USERS_IMAGE_ERROR = "LOAD_ALL_USERS_IMAGE_ERROR";
